import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useGenderSplitUpdateInheritance = (standalone = true) =>
    useUpdateModuleInheritance(Module.GenderSplit, standalone);
